export default "__VITE_ASSET__D_FZdLIU__"